// extracted by mini-css-extract-plugin
export default {"container":"container--mp-z8oq8","link":"link--mp-IsCxm"};